import { Logger } from './logger.model';
import { Injectable } from '@angular/core';
import { LoggerOptions } from './logger.model';
import { WorkerLoggerService } from './worker-logger.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private workerLoggerService: WorkerLoggerService;

  constructor() {
    this.workerLoggerService = new WorkerLoggerService();
  }

  public configure(options?: LoggerOptions) {
    this.workerLoggerService.configure(options);
  }

  public registerTransportType(name: string, transportType: any): void {
    this.workerLoggerService.registerTransportType(name, transportType);
  }

  public getLogger(name: string): Logger {
    return this.workerLoggerService.getLogger(name);
  }
}
